import { getUserLanguage } from '../../i18n/helpers';

import { LANGUAGE_OPTIONS_BY_ID } from './constants';

export const getCurrentLanguageOption = () => LANGUAGE_OPTIONS_BY_ID[getUserLanguage()];
